import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'
import comment from './comment'
import login from '@/utils/login'
import os from '@edu-fe/os'

const name = 'video-detail'

export default {
  name,
  namespaced: true,
  modules: {
    comment
  },
  state () {
    return {
      data: {},
      sourceType: 'm3u8',
      clockInStatus: {},
      // 是否是畅学卡用户
      buyCardFlag: true,
      hasBuy: 0,
      isVisible: true,
    }
  },
  getters: {
    state (state) {
      return ['', 'mp4', 'm3u8'][state.sourceType]
    }
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    },
    addData: (state, data) => assign(state.data, data),
    setClockInStatus: (state, data) => (state.clockInStatus = data)
  },
  actions: {
    async checkLogin (store, canTry = 1) {
      const wpsSid = await login.getWpsSid()

      if (canTry === 1) {
        return wpsSid
      }

      return wpsSid || login.login()
    },

    async 'data:get' ({ getters: { stage }, commit, dispatch, rootState }, _this) {
      _this.$loading.show()
      const { courseId, chapterId } = rootState.route.query
      if (!courseId) {
        return commit(global.ERR, '缺少课程 id', { root: true })
      }
      if (!chapterId) {
        return commit(global.ERR, '缺少章节 id', { root: true })
      }

      const { data } = await api.media.getMediaData({
        courseId,
        chapterId,
        resolution: 1,
        stage,
        client: os.type === 'ali' ? 1 : ''
      })
      commit('set', { data })
      _this.$loading.hide()

      await dispatch('checkLogin', data.canTry)
      await dispatch('getUserInfo', data.canTry, { root: true })

      dispatch('comment/initComment', { wid: chapterId })
    },

    // 获取用户信息，其中 userId 在分享时要用\
    // async getUserInfo ({ commit, rootState }) {
    //   try {
    //     console.log(rootState.userInfo.userId)
    //     commit('addData', { userId: rootState.userInfo.userId })
    //   } catch (e) {
    //     console.log('not login')
    //   }
    // },

    // 获取打卡状态
    async getClockState ({ commit, rootState }) {
      const { chapterId } = rootState.route.query
      const { data } = await api.clockIn.getClockState({ chapterId })
      commit('set', { isVisible: false })
      commit('setClockInStatus', data)
    },

    async init ({ state, dispatch }, _this) {
      await dispatch('data:get', _this)
      await dispatch('getClockState')
      dispatch('getPrivilege', null, { root: true })
      dispatch('checkAuth', _this)
    },

    async videoError ({ state: { sourceType }, commit, dispatch }) {
      if (sourceType === 'm3u8') {
        commit('set', { sourceType: 'mp4' })
      }
      await dispatch('data:get')
    },
    async checkAuth ({ rootState, commit },  _this) {
      const { data } = await api.media.hasBuy(_this.$route.query.courseId)()
      commit('set', { hasBuy: data })
    }
    // 判断畅学卡用户
    // async getPrivilege ({commit}) {
    //   const { data: { isBuy } } = await api.privilege.getPrivilegeInfo()
    //   commit('set', { isBuy })
    // },
    // hideBtn ({state, commit},buyCard) {
    //
    //   if (state.buyCardFlag) {
    //     buyCard.style.right = '-100px'
    //     commit('set', { buyCardFlag: false })
    //   } else {
    //     buyCard.style.right = 0
    //     commit('set', { buyCardFlag: true })
    //   }
    // }
  }
}
